
import { Routes, Route } from "react-router"

import { HomePage } from "../pages/comun/HomePage"

import { NotFoundPage } from "../pages/auth/NotFoundPage"

import { ApiKeysPage } from "../pages/admin/ApiKeysPage"
import { UsuariosPage } from "../pages/admin/UsuariosPage"
import { RegistrosPage } from "../pages/admin/RegistrosPage"

import { AplicacionPage } from "../pages/catalogos/AplicacionPage"
import { EstatusPage } from "../pages/catalogos/EstatusPage"
import { TipoSesionPage } from "../pages/catalogos/TipoSesionPage"
import { DispositivosPage } from "../pages/admin/DispositivosPage"

export const ControlAccesoRoutes = () => {

    return (

        <Routes>
            
            <Route path="/" element={ <HomePage /> } />   
            
            <Route path="/usuarios/" element={ <UsuariosPage /> } />   

            <Route path="/apikeys/" element={ <ApiKeysPage /> } />    

            <Route path="/registros-accesos/" element={ <RegistrosPage /> } />    

            <Route path="/dispositivos/" element={ <DispositivosPage /> } />    

            <Route path="/administracion/catalogos/aplicacion" element={ <AplicacionPage /> } />    

            <Route path="/administracion/catalogos/estatus" element={ <EstatusPage /> } />    

            <Route path="/administracion/catalogos/tipo-sesion" element={ <TipoSesionPage /> } />    

            <Route path="*" element={ <NotFoundPage /> } />

        </Routes>        
    
    )
}